import React from 'react';

type SvgIconProps = {
  height?: number | string;
  width?: number | string;
  active?: boolean;
};

const GamblingIcon: React.FC<SvgIconProps> = ({
  height = 50,
  width = 50,
  active = false,
}) => {
  const strokeColor = active ? '#141740' : '#9C9CC9';

  return (
    <svg
      id="Group_118417"
      data-name="Group 118417"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 50 50"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_28257"
            data-name="Rectangle 28257"
            width="50"
            height="50"
            fill="none"
            stroke={strokeColor}
            strokeWidth="2"
          />
        </clipPath>
      </defs>
      <g id="Group_117570" data-name="Group 117570">
        <g
          id="Group_117569"
          data-name="Group 117569"
          clipPath="url(#clip-path)"
        >
          <path
            id="Path_110810"
            data-name="Path 110810"
            d="M41.426,41.426V32.915l-3.191-3.191V1H4.191V29.723L1,32.915v8.511Z"
            transform="translate(0.064 0.064)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="2"
          />
        </g>
      </g>
      <rect
        id="Rectangle_28258"
        data-name="Rectangle 28258"
        width="8.511"
        height="12.766"
        transform="translate(8.511 15.957)"
        fill="none"
        stroke={strokeColor}
        strokeWidth="2"
      />
      <rect
        id="Rectangle_28259"
        data-name="Rectangle 28259"
        width="8.511"
        height="12.766"
        transform="translate(17.021 15.957)"
        fill="none"
        stroke={strokeColor}
        strokeWidth="2"
      />
      <rect
        id="Rectangle_28260"
        data-name="Rectangle 28260"
        width="8.511"
        height="12.766"
        transform="translate(25.532 15.957)"
        fill="none"
        stroke={strokeColor}
        strokeWidth="2"
      />
      <rect
        id="Rectangle_28261"
        data-name="Rectangle 28261"
        width="25.532"
        height="6.383"
        transform="translate(8.511 5.319)"
        fill="none"
        stroke={strokeColor}
        strokeWidth="2"
      />
      <g id="Group_117572" data-name="Group 117572">
        <g
          id="Group_117571"
          data-name="Group 117571"
          clipPath="url(#clip-path)"
        >
          <path
            id="Path_110811"
            data-name="Path 110811"
            d="M36.979,41v5.319H4V41"
            transform="translate(0.255 2.617)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="2"
          />
          <path
            id="Path_110812"
            data-name="Path 110812"
            d="M44.511,24.383H36V18h8.511a2.127,2.127,0,0,1,2.128,2.128v2.128A2.127,2.127,0,0,1,44.511,24.383Z"
            transform="translate(2.298 1.149)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="2"
          />
          <circle
            id="Ellipse_3793"
            data-name="Ellipse 3793"
            cx="3.191"
            cy="3.191"
            r="3.191"
            transform="translate(42.553 3.191)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="2"
          />
          <line
            id="Line_6831"
            data-name="Line 6831"
            y2="9.574"
            transform="translate(45.745 9.574)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  );
};

export default GamblingIcon;
